/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum SubmissionTypeEnum {
  NewBusiness = "NewBusiness",
  Renewal = "Renewal",
  Rewrite = "Rewrite"
}

export enum SubmissionStatusEnum {
  Indication = "Indication",
  Submitted = "Submitted",
  BindRequested = "BindRequested",
  SubmissionDeclined = "SubmissionDeclined",
  Bound = "Bound",
  ProducerReview = "ProducerReview",
  CarrierReview = "CarrierReview",
  Draft = "Draft",
  Quoted = "Quoted",
  UnderwriterReviewQuote = "UnderwriterReviewQuote",
  Archive = "Archive",
  BindRequestDeclined = "BindRequestDeclined",
  UnderwriterReviewBind = "UnderwriterReviewBind",
  ProducerReviewQuote = "ProducerReviewQuote",
  ProducerReviewBind = "ProducerReviewBind",
}

export enum SubmissionDocumentTypeEnum {
  Declaration = "Declaration",
  LossRun = "LossRun",
  Certificate = "Certificate",
  BindDocument = "BindDocument",
  Acord = "Acord",
  Application = "Application",
  Audit = "Audit",
  Inspection = "Inspection",
  EndorsementApplication = "EndorsementApplication",
  Invoice = "Invoice",
  SubmissionApplication = "SubmissionApplication",
  Policy = "Policy",
  BrokeragePackage = "BrokeragePackage",
  QuoteRequest = "QuoteRequest",
  Endorsement = "Endorsement",
  Notice = "Notice",
  PolicyChangeInvoice = "PolicyChangeInvoice",
  PolicyChangeApplication = "PolicyChangeApplication",
}

export enum SortFieldEnum {
  Type = "Type",
  Status = "Status",
  CreateDate = "CreateDate",
  IndicationNumber = "IndicationNumber",
  SubmissionNumber = "SubmissionNumber",
  Program = "Program",
  BusinessName = "BusinessName",
  PolicyEffectiveDate = "PolicyEffectiveDate",
  ProducerName = "ProducerName",
  AgencyName = "AgencyName",
  AgencyAddress = "AgencyAddress",
  AgentCount = "AgentCount",
  Email = "Email",
  FirstName = "FirstName",
  LastName = "LastName",
  LastUpdated = "LastUpdated",
  RequestType = "RequestType",
  Role = "Role",
  PolicyNumber = "PolicyNumber",
  TenantName = "TenantName",
  FullAddress = "FullAddress",
  Name = "Name",
}

export enum SortDirectionEnum {
  ASCENDING = "ASCENDING",
  DESCENDING = "DESCENDING",
}

export enum QuoteChangeTypeEnum {
  Added = "Added",
  Removed = "Removed",
  Updated = "Updated",
}

export enum ProgramEnum {
  RCIP = "RCIP",
}

export enum PolicyChangeTypeEnum {
  AIManagersLessors = "AIManagersLessors",
  AIOwnersLesseesContractors = "AIOwnersLesseesContractors",
  AICompletedOperations = "AICompletedOperations",
  AIStateGovPolitical = "AIStateGovPolitical",
  AICancellation = "AICancellation",
  AILeasedEquipment = "AILeasedEquipment",
  PolicyIssue = "PolicyIssue",
  NoticeOfCancellation = "NoticeOfCancellation",
  Cancellation = "Cancellation",
  NonRenewal = "NonRenewal",
  Reinstatement = "Reinstatement",
  NoticeOfNonRenewal = "NoticeOfNonRenewal",
  NoticeOfReinstatement = "NoticeOfReinstatement",
  Other = "Other",
  CoverageAdjustment = "CoverageAdjustment",
  AIMortgageeAssigneeOrReceiver = "AIMortgageeAssigneeOrReceiver",
  AIGrantorFranchise = "AIGrantorFranchise",
  FlatCancellation = "FlatCancellation",
  Void = "Void",
}

export enum PolicyChangeStatusEnum {
  Requested = "Requested",
  Issued = "Issued",
  Declined = "Declined",
  Draft = "Draft",
  PendingSignature = "PendingSignature",
  Voided = "Voided",
}

export enum PendingRequestStatusEnum {
  Approve = "Approve",
  Decline = "Decline",
  MoreInfo = "MoreInfo",
}

export enum LossRunsStatusEnum {
  Requested = "Requested",
  Issued = "Issued",
}

export enum DocumentTypeEnum {
  Declaration = "Declaration",
  LossRun = "LossRun",
  Certificate = "Certificate",
  BindDocument = "BindDocument",
  Acord = "Acord",
  Application = "Application",
  Audit = "Audit",
  Inspection = "Inspection",
  EndorsementApplication = "EndorsementApplication",
  Invoice = "Invoice",
  Submission = "Submission",
  Policy = "Policy",
  BrokeragePackage = "BrokeragePackage",
  QuoteRequest = "QuoteRequest",
  Endorsement = "Endorsement",
  Notice = "Notice",
  PolicyChangeInvoice = "PolicyChangeInvoice",
  PolicyChangeApplication = "PolicyChangeApplication",
  FinanceAgreement = "FinanceAgreement",
}

export enum BusinessTypeEnum {
  SoleProprietor = "SoleProprietor",
  Corporation = "Corporation",
  JointVenture = "JointVenture",
  LimitedLiabilityCompany = "LimitedLiabilityCompany",
  Partnership = "Partnership",
  Trust = "Trust",
}

export interface AgencyCommissionViewModel {
  /** @format int32 */
  id?: number | null;
  /** @format int32 */
  programId?: number;
  /** @format double */
  agentCommission?: number;
  /** @format double */
  premiumMin?: number;
  /** @format double */
  premiumMax?: number | null;
}

export interface AgencyGridRowViewModel {
  /** @format int32 */
  tenantId?: number | null;
  tenantName?: string | null;
  /** @format int32 */
  agencyId?: number;
  agencyName?: string | null;
  program?: string | null;
  /** @format int32 */
  agentCount?: number;
  status?: string | null;
  /** @format date */
  createDate?: string;
  fullAddress?: string | null;
}

export interface AgencyGridViewModel {
  /** @format int32 */
  totalCount?: number;
  /** @format int32 */
  totalNumberOfPages?: number;
  rows?: AgencyGridRowViewModel[] | null;
}

export interface AgencyProgramViewModel {
  /** @format int32 */
  programId?: number;
  programName?: string | null;
  checked?: boolean;
}

export interface AgencyUserGridRowViewModel {
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  agencyName?: string | null;
  tenantName?: string | null;
  role?: string | null;
  status?: string | null;
  /** @format date */
  createDate?: string | null;
  /** @format int32 */
  id?: number | null;
  /** @format uuid */
  userInviteGuid?: string | null;
  editUser?: boolean;
  resendInvite?: boolean;
  cancelInvite?: boolean;
}

export interface AgencyUserGridViewModel {
  /** @format int32 */
  totalCount?: number;
  /** @format int32 */
  totalNumberOfPages?: number;
  rows?: AgencyUserGridRowViewModel[] | null;
}

export interface AgencyViewModel {
  /** @format int32 */
  id?: number;
  agencyName?: string | null;
  streetAddress?: string | null;
  suite?: string | null;
  city?: string | null;
  state?: string | null;
  zipCode?: string | null;
  licenseNumber?: string | null;
  phone?: string | null;
  websiteUrl?: string | null;
  isActive?: boolean;
  /** @format int32 */
  boundPolicyCount?: number;
  /** @format int32 */
  submissionCount?: number;
  /** @format date */
  lastUpdatedDate?: string;
  /** @format date */
  createDate?: string;
  lastUpdatedBy?: string | null;
  programs?: AgencyProgramViewModel[] | null;
}

export interface AgentViewModel {
  /** @maxLength 50 */
  firstName?: string | null;
  /** @maxLength 50 */
  lastName?: string | null;
  /** @maxLength 20 */
  phone?: string | null;
  /** @format email */
  email?: string | null;
  role?: string | null;
  /** @format int32 */
  retailAgentId?: number;
  isActive?: boolean;
}

export interface AppVersionViewModel {
  versionNumber?: string | null;
  /** @format date-time */
  createdDate?: string;
}

export interface AuthenitcationAppTotpResetPasswordViewModel {
  /** @minLength 1 */
  email: string;
  /**
   * @minLength 1
   * @pattern ^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W]).{6,}$
   */
  password: string;
  /** @minLength 1 */
  verificationCode: string;
}

export interface BindRequestREQViewModel {
  producerName?: string | null;
  agencyName?: string | null;
  agencyAddress1?: string | null;
  agencyAddress2?: string | null;
  agencyCity?: string | null;
  agencyStateCode?: string | null;
  agencyZipCode?: string | null;
  communicationEmail?: string | null;
  /** @format uuid */
  submissionGuid?: string;
  /** @format date */
  proposedEffectiveDate?: string | null;
  submissionStatus?: SubmissionStatusEnum;
}

export interface BusinessInfo {
  businessName?: string | null;
  primaryAddress?: string | null;
  licenseNumber?: string | null;
  primaryContactName?: string | null;
  primaryContactEmail?: string | null;
  primaryContactPhone?: string | null;
}

export interface ChangePasswordViewModel {
  /** @minLength 1 */
  oldPassword: string;
  /**
   * @minLength 1
   * @pattern ^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W]).{6,}$
   */
  newPassword: string;
}

export interface ChangeSummary {
  classChanges?: ClassChange[] | null;
  endorsementChanges?: EndorsementChange[] | null;
  quoteChanges?: FieldChange[] | null;
  formChanges?: FormChange[] | null;
}

export interface ClassChange {
  classCode?: string | null;
  previousPayroll?: string | null;
  newPayroll?: string | null;
  description?: string | null;
  classChangeType?: QuoteChangeTypeEnum;
}

export interface ClassPremiumBreakDownViewModel {
  zipcode?: string | null;
  classCode?: string | null;
  className?: string | null;
  /** @format double */
  premiumBase?: number;
  /** @format double */
  premOpsRate?: number;
  /** @format double */
  prodOpsRate?: number;
  /** @format double */
  premOpsPremium?: number;
  /** @format double */
  prodOpsPremium?: number;
  /** @format double */
  total?: number;
}

export interface ClassStatement {
  classCode?: string | null;
  className?: string | null;
  classDescription?: string | null;
  eligibleStatement?: string | null;
  ineligibleStatement?: string | null;
}

export interface CredentialsViewModel {
  userName: string | null;
  password: string | null;
}

export interface CredentialsWith2FaViewModel {
  userName: string | null;
  password: string | null;
  verificationCode: string | null;
}

export interface DocumentGridRowViewModel {
  id?: string | null;
  documentType?: string | null;
  /** @format int32 */
  documentTypeId?: number;
  name?: string | null;
  /** @format date-time */
  createdDate?: string;
  createdBy?: string | null;
  /** @format int32 */
  createdById?: number | null;
  isSystemDocument?: boolean;
  canDelete?: boolean;
  isCreatedByShastaAdmin?: boolean;
}

export interface EligibilityStatementRES {
  programStatementSections?: ProgramStatementSection[] | null;
  classStatements?: ClassStatement[] | null;
}

export interface EndorsementChange {
  name?: string | null;
  formNumber?: string | null;
  endorsementChangeType?: QuoteChangeTypeEnum;
}

export interface EndorsementViewModel {
  title?: string | null;
  code?: string | null;
  description?: string | null;
  formNumber?: string | null;
  /** @format double */
  price?: number | null;
  /** @format double */
  debitPercent?: number | null;
  /** @format int32 */
  sort?: number;
}

export interface Fee {
  name?: string | null;
  /** @format double */
  amount?: number;
}

export interface FeeScheduleViewModel {
  /** @format int32 */
  id?: number | null;
  name?: string | null;
  /** @format double */
  amount?: number;
  /** @format double */
  premiumMin?: number;
  /** @format double */
  premiumMax?: number | null;
}

export interface FieldChange {
  fieldName?: string | null;
  previousValue?: string | null;
  newValue?: string | null;
  description?: string | null;
}

export interface ForgotPasswordViewModel {
  email?: string | null;
}

export interface FormChange {
  formName?: string | null;
  formNumber?: string | null;
  formChangeType?: QuoteChangeTypeEnum;
}

export interface FormViewModel {
  /** @format int32 */
  formId?: number;
  title?: string | null;
  formNumber?: string | null;
  required?: string | null;
  url?: string | null;
  /** @format date-time */
  validFromDate?: string;
  /** @format date-time */
  validToDate?: string | null;
  /** @format date-time */
  formDate?: string | null;
  notes?: string | null;
  program?: string | null;
  state?: string | null;
}

export interface LookupViewModel {
  id?: string | null;
  name?: string | null;
  isDefault?: boolean;
}

export interface LossRunReviewViewModel {
  /** @format uuid */
  lossRunRequestGuid?: string;
  dba?: string | null;
  contractorLicenseNumber?: string | null;
  businessType?: string | null;
  address1?: string | null;
  address2?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  agencyName?: string | null;
  producerName?: string | null;
  policyNumber?: string | null;
  policyPeriod?: string | null;
  /** @format uuid */
  submissionGuid?: string;
}

export interface LossRunsRequestGridRowViewModel {
  /** @format uuid */
  guid?: string;
  /** @format date-time */
  createDate?: string;
  type?: string | null;
  policyTerm?: string | null;
  comments?: string | null;
  status?: LossRunsStatusEnum;
  lastModifiedBy?: string | null;
}

export interface LossRunsRequestGridViewModel {
  /** @format int32 */
  totalCount?: number;
  /** @format int32 */
  totalNumberOfPages?: number;
  rows?: LossRunsRequestGridRowViewModel[] | null;
}

export interface LossRunsRequestREQ {
  /** @format uuid */
  policyGuid: string;
}

export interface LossRunsRequestRES {
  /** @format uuid */
  guid?: string;
  /** @format int32 */
  statusId?: number;
}

export interface MGAPremiumBreakDownDetailViewModel {
  classPremiumBreakDown?: ClassPremiumBreakDownViewModel[] | null;
  /** @format double */
  minimumPremiumAdjustment?: number;
  /** @format double */
  endorsementPremium?: number;
  /** @format double */
  totalRatedPremium?: number;
  /** @format double */
  scheduleCredit?: number;
  scheduleCreditDiscount?: string | null;
}

export interface OptionalCoverageDetail {
  title?: string | null;
  code?: string | null;
  description?: string | null;
  formNumber?: string | null;
  /** @format double */
  price?: number | null;
  /** @format double */
  debitPercent?: number | null;
  /** @format int32 */
  sort?: number;
  /** @format double */
  premium?: number;
}

export interface PendingRequestGridRowViewModel {
  /** @format uuid */
  id?: string;
  tenantName?: string | null;
  /** @format date-time */
  lastUpdated?: string;
  requestType?: string | null;
  submissionNumber?: string | null;
  policyNumber?: string | null;
  /** @format uuid */
  policyGuid?: string | null;
  program?: string | null;
  businessName?: string | null;
  /** @format date */
  effectiveDate?: string;
  /** @format date */
  proposedEffectiveDate?: string | null;
  producerName?: string | null;
  agencyName?: string | null;
}

export interface PendingRequestGridViewModel {
  /** @format int32 */
  totalCount?: number;
  /** @format int32 */
  totalNumberOfPages?: number;
  rows?: PendingRequestGridRowViewModel[] | null;
}

export interface RenewalPayrollRequestViewModel {
  /** @format int32 */
  numberOfFieldOwners: number;
  /** @format int32 */
  numberOfEmployees: number;
  /** @format int32 */
  employeePayroll: number;
  classes: WizardClassViewModel[];
}

export interface PendingSubmissionRequestREQ {
  producerName?: string | null;
  agencyName?: string | null;
  agencyAddress1?: string | null;
  agencyAddress2?: string | null;
  agencyCity?: string | null;
  agencyStateCode?: string | null;
  agencyZipCode?: string | null;
  communicationEmail?: string | null;
  removePriorWork?: boolean | null;
  /** @format date */
  priorWorksEffectiveDate?: string | null;
  /** @format date */
  issuedEffectiveDate?: string | null;
  status?: PendingRequestStatusEnum;
  comments?: string | null;
  /** @format uuid */
  id?: string;
  updatePolicyEffectiveDate?: boolean | null;
  /** @format date */
  policyEffectiveDate?: string | null;
}

export interface PolicyChangeGridViewModel {
  /** @format int32 */
  totalCount?: number;
  /** @format int32 */
  totalNumberOfPages?: number;
  rows?: PolicyChangeRowViewModel[] | null;
}

export interface PolicyChangeQuoteViewModel {
  /** @format double */
  additionalPremium?: number;
  /** @format double */
  surplusLinesTax?: number;
  /** @format double */
  stampingFee?: number;
  /** @format double */
  totalPrice?: number;
  summaryOfChanges?: ChangeSummary;
}

export interface PolicyChangeRowViewModel {
  /** @format uuid */
  policyChangeGuid?: string;
  policyChangeType?: PolicyChangeTypeEnum;
  policyChangeStatus?: PolicyChangeStatusEnum;
  /** @format date-time */
  createDate?: string;
  createdBy?: string | null;
  lastUpdatedBy?: string | null;
  category?: string | null;
  changeType?: string | null;
  details?: string | null;
  formJSON?: string | null;
  /** @format uuid */
  policyEventId?: string | null;
  endorsementNumber?: string | null;
  summaryOfChanges?: ChangeSummary;
  isVoidable?: boolean;
}

export interface PolicyChangeViewModel {
  /** @format uuid */
  policyChangeGuid?: string | null;
  /** @format uuid */
  policyGuid: string;
  policyChangeType: PolicyChangeTypeEnum;
  formJSON: string | null;
  documents?: File[] | null;
  policyChangeStatus?: PolicyChangeStatusEnum;
}

export interface PolicyIssuanceViewModel {
  producerName?: string | null;
  agencyName?: string | null;
  agencyAddress1?: string | null;
  agencyAddress2?: string | null;
  agencyCity?: string | null;
  agencyStateCode?: string | null;
  agencyZipCode?: string | null;
  communicationEmail?: string | null;
  removePriorWork?: boolean | null;
  /** @format date */
  priorWorksEffectiveDate?: string | null;
  /** @format date */
  issuedEffectiveDate?: string | null;
}

export interface ProblemDetails {
  type?: string | null;
  title?: string | null;
  /** @format int32 */
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
}

export interface ProgramStatementSection {
  statement?: string | null;
}

export interface ProgramTileSectionViewModel {
  sectionHeader?: string | null;
  programTiles?: ProgramTileViewModel[] | null;
}

export interface ProgramTileViewModel {
  imageUrl?: string | null;
  heading?: string | null;
  subHeading?: string | null;
  statusText?: string | null;
  showButton?: boolean | null;
  isExternal?: boolean | null;
  routingUrl?: string | null;
}

export interface QuoteBreakdownViewModel {
  /** @format double */
  ratedPremium?: number;
  /** @format double */
  inspectionFee?: number;
  /** @format double */
  mgaFee?: number;
  /** @format double */
  retailBrokerFee?: number;
  optionalForms?: OptionalCoverageDetail[] | null;
  additionalProgramFees?: Fee[] | null;
  additionalMGAFees?: Fee[] | null;
  /** @format double */
  surplusLinesTax?: number;
  /** @format double */
  stampingFee?: number;
  indicationNumber?: string | null;
  /** @format double */
  total?: number;
}

export interface RCIPCoverageAdjustmentViewModel {
  /** @format double */
  brokerFee?: number | null;
  submissionType?: SubmissionTypeEnum;
  /** @format double */
  scheduleCredit?: number;
  /** @format int32 */
  agencyId?: number | null;
  /** @format int32 */
  producerId?: number | null;
  /** @format date */
  effectiveDate?: string;
  licenseNumber?: string | null;
  businessType?: BusinessTypeEnum;
  /**
   * @format int32
   * @min 0
   * @max 40
   */
  numberOfEmployees?: number | null;
  hasEmployees?: boolean | null;
  businessName?: string | null;
  locationAddress1?: string | null;
  locationAddress2?: string | null;
  city?: string | null;
  state?: string | null;
  zipCode?: string | null;
  meetsContinualCoverageFirstThreshold?: boolean | null;
  performsNewResConstruction?: boolean | null;
  /** @format int32 */
  grossReceipts?: number;
  /** @format int32 */
  residentialSubcontractorCosts?: number;
  /** @format int32 */
  commercialSubcontratorCosts?: number;
  /** @format int32 */
  deductible?: number | null;
  occurenceAggregateLimit?: string | null;
  classes?: WizardClassViewModel[] | null;
  endorsements?: string[] | null;
  mailingSameAsBusiness?: boolean;
  mailingStreetAddress?: string | null;
  mailingAptSuiteBuilding?: string | null;
  mailingCity?: string | null;
  mailingState?: string | null;
  mailingZipCode?: string | null;
  contactFirstName?: string | null;
  contactLastName?: string | null;
  contactEmail?: string | null;
  contactPhone?: string | null;
  contactCellPhone?: string | null;
  inspectionContactFirstName?: string | null;
  inspectionContactLastName?: string | null;
  inspectionContactEmail?: string | null;
  inspectionContactPhone?: string | null;
  inspectionContactCellPhone?: string | null;
  inspectionContactSameAsPrimary?: boolean;
  descriptionOfOperations?: string | null;
  /** @format int32 */
  percentageResidentialNew?: number;
  /** @format int32 */
  percentageResidentialRemodel?: number;
  /** @format int32 */
  percentageCommercialNew?: number;
  /** @format int32 */
  percentageCommercialRemodel?: number;
  /** @format int32 */
  percentageIndustrialNew?: number;
  /** @format int32 */
  percentageIndustrialRemodel?: number;
  agreeWithEligibilityStatement?: boolean | null;
  disabledEndorsements?: string[] | null;
  performsNewResConstructionDisabled?: boolean;
  /** @format date-time */
  endorsementEffectiveDate?: string | null;
}

export interface RCIPWizardViewModel {
  /** @format double */
  brokerFee?: number | null;
  submissionType?: SubmissionTypeEnum;
  /** @format double */
  scheduleCredit?: number;
  /** @format int32 */
  agencyId?: number | null;
  /** @format int32 */
  producerId?: number | null;
  /** @format date */
  effectiveDate?: string;
  licenseNumber?: string | null;
  businessType?: BusinessTypeEnum;
  /**
   * @format int32
   * @min 0
   * @max 40
   */
  numberOfEmployees?: number | null;
  hasEmployees?: boolean | null;
  businessName?: string | null;
  locationAddress1?: string | null;
  locationAddress2?: string | null;
  city?: string | null;
  state?: string | null;
  zipCode?: string | null;
  meetsContinualCoverageFirstThreshold?: boolean | null;
  performsNewResConstruction?: boolean | null;
  /** @format int32 */
  grossReceipts?: number;
  /** @format int32 */
  residentialSubcontractorCosts?: number;
  /** @format int32 */
  commercialSubcontratorCosts?: number;
  /** @format int32 */
  deductible?: number | null;
  occurenceAggregateLimit?: string | null;
  classes?: WizardClassViewModel[] | null;
  endorsements?: string[] | null;
  mailingSameAsBusiness?: boolean;
  mailingStreetAddress?: string | null;
  mailingAptSuiteBuilding?: string | null;
  mailingCity?: string | null;
  mailingState?: string | null;
  mailingZipCode?: string | null;
  contactFirstName?: string | null;
  contactLastName?: string | null;
  contactEmail?: string | null;
  contactPhone?: string | null;
  contactCellPhone?: string | null;
  inspectionContactFirstName?: string | null;
  inspectionContactLastName?: string | null;
  inspectionContactEmail?: string | null;
  inspectionContactPhone?: string | null;
  inspectionContactCellPhone?: string | null;
  inspectionContactSameAsPrimary?: boolean;
  descriptionOfOperations?: string | null;
  /** @format int32 */
  percentageResidentialNew?: number;
  /** @format int32 */
  percentageResidentialRemodel?: number;
  /** @format int32 */
  percentageCommercialNew?: number;
  /** @format int32 */
  percentageCommercialRemodel?: number;
  /** @format int32 */
  percentageIndustrialNew?: number;
  /** @format int32 */
  percentageIndustrialRemodel?: number;
  agreeWithEligibilityStatement?: boolean | null;
}

export interface SelfUserUpdateREQ {
  /** @maxLength 50 */
  firstName?: string | null;
  /** @maxLength 50 */
  lastName?: string | null;
  /** @maxLength 20 */
  phone?: string | null;
}

export interface SubmissionReviewViewModel {
  businessName?: string | null;
  businessType?: string | null;
  licenseNumber?: string | null;
  programName?: string | null;
  programCode?: string | null;
  retailAgency?: string | null;
  retailProducer?: string | null;
  submissionNumber?: string | null;
  submissionType?: string | null;
  businessAddress?: string | null;
  city?: string | null;
  state?: string | null;
  zipCode?: string | null;
  requestType?: string | null;
  /** @format int32 */
  grossReceipts?: number;
  /** @format int32 */
  residentialSubcontractorCosts?: number;
  /** @format int32 */
  commercialSubcontractorCosts?: number;
  currentAndContinualCoverage?: string | null;
  yearsContinualCoverage?: string | null;
  /** @format date */
  effectiveDate?: string | null;
  descriptionOfOperations?: string | null;
  /** @format int32 */
  totalPayroll?: number;
  /** @format double */
  ratedPremium?: number;
  /** @format double */
  inspectionFee?: number;
  /** @format double */
  brokerFee?: number;
  /** @format double */
  mgaFee?: number;
  /** @format double */
  surplusLinesTax?: number;
  /** @format double */
  stampingOfficeFee?: number;
  /** @format double */
  total?: number;
  /** @format double */
  scheduleCredit?: number;
  /** @format int32 */
  numberOfEmployees?: number;
  /** @format int32 */
  numberOfFieldOwners?: number | null;
  /** @format int32 */
  ownerPayroll?: number | null;
  /** @format int32 */
  employeePayroll?: number | null;
  payrollDefaultedByRenewal?: boolean;
  classifications?: Record<string, number>;
  classPercentagesOfWork?: Record<string, number>;
  additionalFees?: Record<string, number>;
  optionalCoverages?: Record<string, string>;
  percentageOfWork?: Record<string, number>;
}

export interface SubmissionSummaryViewModel {
  producerName?: string | null;
  agencyName?: string | null;
  agencyAddress1?: string | null;
  agencyAddress2?: string | null;
  agencyCity?: string | null;
  agencyStateCode?: string | null;
  agencyZipCode?: string | null;
  communicationEmail?: string | null;
  /** @format int32 */
  retailAgentId?: number | null;
  /** @format int32 */
  retailAgencyId?: number | null;
  submissionNumber?: string | null;
  /** @format uuid */
  submissionGuid?: string;
  policyNumber?: string | null;
  /** @format uuid */
  policyGuid?: string | null;
  programName?: string | null;
  status?: string | null;
  friendlyStatus?: string | null;
  lastUpdatedBy?: string | null;
  lastUpdatedByRole?: string | null;
  requestType?: string | null;
  underwriterComments?: string | null;
  /** @format date */
  policyEffectiveDate?: string;
  /** @format date */
  policyExpirationDate?: string | null;
  /** @format date-time */
  createDate?: string;
  /** @format double */
  price?: number | null;
  /** @format date-time */
  lastModifiedDate?: string;
  businessInfo?: BusinessInfo;
}

export interface TPolicyGridRowViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  lastUpdated?: string;
  status?: string | null;
  type?: string | null;
  policyNumber?: string | null;
  submissionNumber?: string | null;
  program?: string | null;
  businessName?: string | null;
  /** @format date */
  policyEffectiveDate?: string | null;
  producerName?: string | null;
  agencyName?: string | null;
  contactName?: string | null;
  /** @format int32 */
  tenantId?: number;
  tenantName?: string | null;
}

export interface TPolicyGridViewModel {
  /** @format int32 */
  totalCount?: number;
  /** @format int32 */
  totalNumberOfPages?: number;
  rows?: TPolicyGridRowViewModel[] | null;
}

export interface TSubmissionGridRowViewModel {
  /** @format uuid */
  submissionGuid?: string;
  /** @format date-time */
  createDate?: string;
  type?: string | null;
  status?: string | null;
  indicationNumber?: string | null;
  submissionNumber?: string | null;
  program?: string | null;
  businessName?: string | null;
  /** @format date */
  policyEffectiveDate?: string | null;
  producerName?: string | null;
  agencyName?: string | null;
  /** @format int32 */
  tenantId?: number;
  tenantName?: string | null;
}

export interface TSubmissionGridViewModel {
  /** @format int32 */
  totalCount?: number;
  /** @format int32 */
  totalNumberOfPages?: number;
  rows?: TSubmissionGridRowViewModel[] | null;
}

export interface TenantFeesViewModel {
  agencyCommissions?: AgencyCommissionViewModel[] | null;
  adhocFeeSchedules?: FeeScheduleViewModel[] | null;
  mgaFees?: FeeScheduleViewModel[] | null;
}

export interface TenantViewModel {
  /** @format int32 */
  id?: number | null;
  name?: string | null;
  subdomain?: string | null;
  address1?: string | null;
  address2?: string | null;
  city?: string | null;
  /** @format int32 */
  stateId?: number;
  zipCode?: string | null;
  phone?: string | null;
  license?: string | null;
  website?: string | null;
  /** @format double */
  commission?: number | null;
  programIds?: number[] | null;
}

export interface TenantsGridRowViewModel {
  /** @format int32 */
  tenantId?: number;
  companyName?: string | null;
  address?: string | null;
  license?: string | null;
  tenantSubdomain?: string | null;
  status?: string | null;
  createdDate?: string | null;
}

export interface TenantsGridViewModel {
  /** @format int32 */
  totalCount?: number;
  /** @format int32 */
  totalNumberOfPages?: number;
  rows?: TenantsGridRowViewModel[] | null;
}

export interface ToolbarTileViewModel {
  iconName?: string | null;
  label?: string | null;
  data?: string | null;
}

export interface ToolbarTilesViewModel {
  tiles?: ToolbarTileViewModel[] | null;
}

export interface UpdateProducerViewModel {
  producerName?: string | null;
  agencyName?: string | null;
  agencyAddress1?: string | null;
  agencyAddress2?: string | null;
  agencyCity?: string | null;
  agencyStateCode?: string | null;
  agencyZipCode?: string | null;
  communicationEmail?: string | null;
  /** @format int32 */
  agentId?: number | null;
}

export interface UserViewModel {
  /** @maxLength 50 */
  firstName?: string | null;
  /** @maxLength 50 */
  lastName?: string | null;
  /** @maxLength 20 */
  phone?: string | null;
  /** @format int32 */
  id?: number | null;
  /** @format date-time */
  createDate?: string | null;
  /** @maxLength 50 */
  email?: string | null;
  /** @format int32 */
  agencyId?: number | null;
  /** @format int32 */
  producerId?: number | null;
  roles?: string[] | null;
  status?: string | null;
  /** @format uuid */
  userInviteGuid?: string | null;
  editUser?: boolean;
  resendInvite?: boolean;
  cancelInvite?: boolean;
}

export interface VerifyLoginResponse {
  requiresQRSetup?: boolean;
  /** @format byte */
  qrCode?: string | null;
}

export interface WizardClassViewModel {
  classCode?: string | null;
  /** @format int32 */
  payroll?: number;
}
